import React, { createContext, useContext, useState, ReactNode } from 'react';

interface OverlayAction {
  label: string;
  onClick: () => void;
  icon: React.ReactNode;
  closeOnClick?: boolean;  // Optionnel: ferme le menu après clic si true
}

interface ActionsContextType {
  actions: OverlayAction[];
  setActions: (actions: OverlayAction[]) => void;
}

const OverlayActionsContext = createContext<ActionsContextType | undefined>(undefined);

export function OverlayActionsProvider({ children }: { children: ReactNode }) {
  const [actions, setActions] = useState<OverlayAction[]>([]);
  return (
    <OverlayActionsContext.Provider value={{ actions, setActions }}>
      {children}
    </OverlayActionsContext.Provider>
  );
}

export function useOverlayActions() {
  const ctx = useContext(OverlayActionsContext);
  if (!ctx) throw new Error('useOverlayActions must be used within an OverlayActionsProvider');
  return ctx;
}
